import * as React from 'react'
import * as style from './style.module.scss'

export default function SnappySlider(props) {
  return <div className={style.snappySlider} {...props} />
}
